import { Headphones } from 'lucide-react';
import { PageContainer } from '@/components/common/PageContainer';
import { ContactChannels } from '@/components/features/support/ContactChannels';
import { ContactForm } from '@/components/features/support/ContactForm';
import { FaqAccordion } from '@/components/features/support/FaqAccordion';
import { useI18n } from '@/contexts/I18nContext';
import { useAuth } from '@/hooks/useAuth';

/**
 * Support / contact page for tenants and carriers. Static contact channels and
 * a role-aware FAQ, plus a contact form that emails QuBox support.
 */
export default function Support() {
  const { tp } = useI18n();
  const { user } = useAuth();
  const s = tp.support;

  // Carriers see carrier-oriented content; everyone else gets the tenant set.
  const isCarrier = user?.role === 'carrier';
  const categories = isCarrier ? s.carrierCategories : s.tenantCategories;
  const faq = isCarrier ? s.carrierFaq : s.tenantFaq;

  return (
    <PageContainer>
      <div className="mb-6 flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
          <Headphones className="h-5 w-5 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-bold">{s.pageTitle}</h1>
          <p className="text-sm text-muted-foreground">{s.pageSubtitle}</p>
        </div>
      </div>

      <div className="mb-6 grid grid-cols-1 items-start gap-6 lg:grid-cols-2">
        <ContactChannels />
        <ContactForm categories={categories} />
      </div>

      <FaqAccordion faq={faq} />
    </PageContainer>
  );
}
